(function ($, Cobalt, undefined) {
    var _regionData = {};

    Cobalt.PageStructureManager =
    {
        structureID: null,
        getRegion: function (slug) {
            return _regionData[slug];
        },
        initialize: function () {


            // Wire up the show deleted checkbox
            $("input#show-deleted").change(function () {
                var isChecked = $(this).is(":checked");
                $("#page-blocks-container").attr("data-show-deleted", isChecked);
                $.cookie("Cobalt.ImageManager.showDeleted", (isChecked ? "1" : "0"), { path: "/", expires: 365 });
            });

            // Process the show deleted cookie
            var showDeleted = $.cookie("Cobalt.ImageManager.showDeleted");
            if (showDeleted != null && showDeleted == "1") {
                $("input#show-deleted").attr("checked", true);
                $("input#show-deleted").trigger("change");
            }

            // Wire up the page structure list
            $("#page-structure-options").change(function () {
                var value = $(this).val();
                self.location = "/cp/page-structure/" + value;
            });

            var pageStructureID = $("div#page-blocks-cp").attr("data-page-structure-id");
            Cobalt.PageStructureManager.structureID = parseInt(pageStructureID);

            // Append the section data
            $("div#page-blocks-layout div.j-page-region").each(function () {
                var $regionContainer = $(this);
                var $inheritedBlocks = $(this).find("div.j-inherited-blocks > div.j-page-block");
                var slug = $regionContainer.attr("data-slug"); // Get the region slug
                var isLocked = $regionContainer.attr("data-locked") == "true"; // Get the region slug
                var region = new Cobalt.PageRegion( // Construct a new region (JS Class)
                    {
                    "structureID": pageStructureID,
                    "slug": slug,
                    "isLocked": isLocked,
                    "blocks": [],
                    "container": $regionContainer,
                    "inheritedBlocks": $inheritedBlocks
                });

                $regionContainer.data("page-region", region); // Establish a pointer between the dom element and the JS class.

                // Process all placed blocks
                if (!isLocked) {
                    $regionContainer.find("div.j-page-block").each(function () {
                        var $blockElement = $(this);
                        region.addBlock($blockElement, true);
                    });
                }

                _regionData[slug] = region;
            });

            $.log(_regionData);

            // Make all page blocks in the gallery draggable
            $("div#page-blocks-gallery > div.page-block").draggable(
                {
                    containment: "#page-blocks-cp",
                    helper: "clone",
                    revert: "invalid",
                    handle: ".drag-handle",
                    stop: function (event, ui) {
                        $.log("Dragging stopped!");
                    }
                }
            );

            // Make all placed page blocks in the gallery draggable
            $("div#page-blocks-layout div.j-dropzone > div.page-block").draggable(
                {
                    revert: "invalid",
                    helper: "clone",
                    handle: ".drag-handle",
                    stop: function (event, ui) {
                        $.log("Dragging stopped!");
                    }
                }
            );

            // Make all drop zones droppable
            $("div#page-blocks-layout div.p-page-region > div.j-dropzone").droppable(
                {
                    hoverClass: "droppable-hover",
                    accept: ".j-page-block",
                    drop: function (evt, ui) {
                        var $draggable = ui.draggable;
                        var draggableParentID = $draggable.parent().attr("id");
                        var isFromGallery = (draggableParentID == "page-blocks-gallery");
                        var $droppable = $(this);
                        $.log($droppable);
                        var $regionContainer = $droppable.parents("div.p-page-region");

                        if ($regionContainer.attr("data-locked") == "true") {
                            return;
                        }
                        var pageRegion = $regionContainer.data("page-region");

                        if (isFromGallery) {
                            // Create the html element for the block
                            var $newDraggable = $draggable.clone();
                            $newDraggable.find("span.title").removeClass("tip");
                            $newDraggable.draggable(
                                {
                                    revert: "invalid",
                                    helper: "clone",
                                    handle: ".drag-handle"
                                }
                            );

                            $.log($newDraggable);

                            // Create the JS class for the block                            
                            pageRegion.addBlock($newDraggable);
                        }
                        else {
                            var block = $draggable.data("page-block");
                            if (block == null) {
                                return;
                            }
                            $.log("Block Dragged:");
                            $.log(block);
                            if (block.region != pageRegion) {
                                block.moveTo(pageRegion);
                            }
                        }
                    }
                }
            );

            $("div#page-blocks-layout div.j-page-region[data-locked=true] > div.j-dropzone").droppable("option", "disabled", true);

            // Make dropzones sortable
            $("div#page-blocks-layout div.p-page-region > div.j-dropzone").each(function () {
                var axis = $(this).parent().hasClass("p-page-region-orientation-horizontal") ? null : "y";
                $(this).sortable(
                {
                    handle: ".sort-handle",
                    axis: axis,
                    tolerance: "pointer",
                    stop: function (event, ui) {
                        var $elem = ui.item;
                        var block = $elem.data("page-block");
                        $(this).removeAttr("style");
                        block.region.saveBlockPlacements();
                    }
                });
            });

            // Wire up the delete buttons
            $("div#page-blocks-layout").delegate("div.page-block ul.micro-controls a.delete", "click", function () {

                var $blockElement = $(this).parents("div.j-page-block");
                var block = $blockElement.data("page-block");
                if (confirm("Are you sure you want to remove this block?")) {
                    block.remove();
                }
            });

            // Wire up the undelete buttons
            $("div#page-blocks-layout").delegate("div.page-block ul.micro-controls a.undelete", "click", function () {

                var $blockElement = $(this).parents("div.j-page-block");
                var block = $blockElement.data("page-block");
                block.undelete();
            });

            // Wire up the edit buttons
            $("div#page-blocks-layout").delegate("div.page-block ul.micro-controls a.configure", "click", function () {

                var $blockElement = $(this).parents("div.j-page-block");
                var block = $blockElement.data("page-block");
                block.configure();

            });

            // Wire up the edit buttons
            $("div#page-blocks-layout").delegate("div.j-page-region > div.region-title > ul.micro-controls a.configure", "click", function () {

                var $blockElement = $(this).parents("div.j-page-region");
                var region = $blockElement.data("page-region");
                region.configure();
            });

            // Lock Button
            $("div#page-blocks-layout").delegate("div.j-page-region > div.region-title > ul.micro-controls a.lock", "click", function () {
                if (!confirm("Are you sure you want to lock this region? Doing so will delete any existing blocks, and use the default page structure's blocks.")) {
                    return;
                }
                var region = $(this).parents("div.j-page-region").data("page-region");
                region.lock();
                $("div#page-blocks-layout div.j-page-region[data-locked=true] > div.j-dropzone").droppable("option", "disabled", true);
            });


            // Unlock Button
            $("div#page-blocks-layout").delegate("div.j-page-region > div.region-title > ul.micro-controls a.unlock", "click", function () {
                if (!confirm("Are you sure you want to unlock this region? Doing so will clone the existing blocks, and allow you to change them.")) {
                    return;
                }
                var region = $(this).parents("div.j-page-region").data("page-region");
                region.unlock();
            });

            // Create New Structure
            $("div#page-blocks-toolbar > ul > li > a.new-structure").click(function () {
                $.get("/cp/page-structure/create", function (data) {
                    Cobalt.PageStructureManager.createPageStructureModal("Create a New Page Structure", data.html);
                });

            });

            // Edit Current Structure
            $("div#page-blocks-toolbar > ul > li > a.edit-structure").click(function () {
                $.get("/cp/page-structure/" + Cobalt.PageStructureManager.structureID + "/edit", function (data) {
                    Cobalt.PageStructureManager.createPageStructureModal("Edit Page Structure", data.html);
                });

            });

            // Duplicate Current Structure
            $("div#page-blocks-toolbar > ul > li > a.dup-structure").click(function () {

                if (confirm("Are you sure you want to duplicate this page structure?")) {
                    $.get("/cp/page-structure/" + Cobalt.PageStructureManager.structureID + "/duplicate", function (data) {
                        if (data.Success) {
                            Cobalt.PageStructureManager.createPageStructureModal("Edit Page Structure", data.html);
                        }
                    });
                }
            });

            Cobalt.runOnHtmlInsert(function () {
                $("#page-block-form").delegate("select.j-target-type", "change", function () {
                    var $selectElem = $(this);
                    var val = $selectElem.val();
                    var $parent = $selectElem.parents("li");
                    $parent.find(".j-target-fields").hide();
                    $parent.find(".j-target-fields-" + val).show();
                });

                $("#page-block-form").find("select.j-target-type").trigger("change");

                $('#form-field-enable-responsive').click(function (e) {
                    var $scaleField = $('#field-user-scalable');
                    if (!$(this).find("input").is(":checked")) {
                        $scaleField.attr('disabled', 'disabled');
                    } else {
                        $scaleField.removeAttr('disabled');
                    }
                });

            });

            Cobalt.runOnHtmlInsert(function () {
                $("#page-block-form .b-tab-item[data-markup-mode='markup']").click();
                var refreshIntervalId = setInterval(function () {
                    if ($("#page-block-form .markup-selector").length) {
                        $("#page-block-form .b-tab-item[data-markup-mode='markup']").click();
                        $("#page-block-form .markup-selector").val("6");
                        $("#page-block-form .markup-selector").hide();
                        clearInterval(refreshIntervalId);
                    }
                }, 200);
            });

        },
        createPageStructureModal: function (title, html) {
            var $editDiv = $('<div>');
            $editDiv.html(html);
            $editDiv.dialog({
                modal: true,
                dialogClass: "modal category-modal",
                draggable: false,
                title: title,
                resizable: false,
                close: function (event, ui) {
                    $(event.target).dialog("destroy");
                    $(event.target).remove();
                }
            });

            $editDiv.parent().center({ sizeToWindow: true, maxWidth: 640, maxHeight: 510, minHeight: 540 });

            $editDiv.find("form").ajaxForm(
            {
                type: "POST",
                dataType: "json",
                beforeSubmit: function () {

                },
                success: function (result) {
                    $editDiv.dialog("close");
                    if (!result.Success) {
                        Cobalt.PageStructureManager.createPageStructureModal(title, result.html);
                    }
                    else {
                        if (result.structureID != Cobalt.PageStructureManager.structureID) {
                            self.location = "/cp/page-structure/" + result.structureID;
                        }
                        else if (result.requiresReload) {
                            self.location.reload();
                        }
                    }
                    return false;
                }
            });
            $.log("Html Syncing!");
            Cobalt.triggerHtmlInsert($editDiv);

            // find any errors
            var errorFields = $editDiv.find(".field-errors");

            if (errorFields.length > 0) {
                var $firstErrorField = $(errorFields[0]);
                var erroredTabID = $firstErrorField.parents("div.tab-content-item").attr("data-tab-id");
                var erroredTabItem = $firstErrorField.parents("form").find("ul.tabbed-tabs").find("li[data-tab-id=" + erroredTabID + "]>a");
                erroredTabItem.trigger('click');
            }
        }
    };
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.PageStructureManager.js